import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowRedoDown: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconArrowRedoDown"><Path d="M18.5855 16L15.5856 18.9998L16.9998 20.4141L22.4141 14.9998L16.9998 9.58564L15.5856 10.9998L18.5858 14H4V7H13V5H2V16H18.5855Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowRedoDown;
